import {
  FormFieldBlueprint,
  createFormField,
} from '@backstage/plugin-scaffolder-react/alpha';
import {
  MigrationServiceTable,
  MigrationServiceTableSchema,
} from './MigrationServiceTable';

export const MigrationServiceTableExtension = FormFieldBlueprint.make({
  name: 'MigrationServiceTable',
  // FormFieldBlueprint takes params as a PLAIN OBJECT. (ApiBlueprint is the
  // odd one out and needs the callback form.)
  params: {
    field: async () =>
      createFormField({
        name: 'MigrationServiceTable',
        component: MigrationServiceTable,
        schema: MigrationServiceTableSchema,
      }),
  },
});
